import { Dispatch } from "redux";
import {
  ERROR_LOADING_PORTAL,
  GET_DATA_PORTAL,
  RESET_DATA_DETAIL_PORTAL,
  START_LOADING_PORTAL,
  STOP_LOADING_PORTAL,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchDataPortalDetailAction =
  (id: any) => async (dispatch: any, getState: any) => {
    dispatch({ type: START_LOADING_PORTAL });
    try {
      const { data } = await apiLibrary.DataPortal.getDetailDataPortal(id);
      dispatch({
        type: GET_DATA_PORTAL,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA_DETAIL_PORTAL,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_PORTAL });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_PORTAL });
      // dispatch(loadingState(false))
    }
  };

  export const resetDataPortalState = () => {
    return{
      type: RESET_DATA_DETAIL_PORTAL,
    }
  }
